import { Component, EventEmitter, Output } from '@angular/core';

export interface CancelEditResult {
  discard: boolean;
}

@Component({
  selector: 'app-save-without-change-modal',
  templateUrl: './save-without-change-modal.component.html',
  styleUrls: ['./save-without-change-modal.component.css'],
})
export class SaveWithoutChangeModalComponent {
  @Output() onClose = new EventEmitter<CancelEditResult>();

  constructor() {}

  keepEditing(): void {
    this.onClose.emit({ discard: false });
  }

  discardChanges(): void {
    this.onClose.emit({ discard: true });
  }
}
